<template>
  <div class="page-content infinite-scroll noScroll">
    <div v-if="isShowSignIn" class="sign-popup">
      <div class="sign-imgpopup">
        <div class="sign-text">
          已连续签到{{continuousSigInDays}}天
        </div>
        <img
          src="https://mobile.rcclchina.com.cn/reward/img/sign_in_bg.54b01f5e.png"
          alt=""
        />
        <img
          @click="closeCheckedIn"
          class="sign-close"
          src="../../assets/close.png"
          alt=""
        />
      </div>
    </div>
    <div v-if="isShowSignIn" class="sign-popup">
      <div class="sign-imgpopup">
        <div class="sign-text" >
            已连续签到{{continuousSigInDays}}天
        </div>
        <img
          src="https://mobile.rcclchina.com.cn/reward/img/sign_in_bg.54b01f5e.png"
          alt=""
        />
        <img
          @click="closeSignIn"
          class="sign-close"
          src="../../assets/close.png"
          alt=""
        />
      </div>
    </div>
    <div class="individual-center scroll-container">
      <div class="banner">
        <img
          class="hp-banner"
          v-bind:class="{ active: cruiseLink === 'ch' }"
          src="https://resource.rcclchina.com.cn/userCenter/usercenter_banner_hp.png"
        />
        <img
          class="row-banner"
          v-bind:class="{ active: cruiseLink === 'fn' }"
          src="https://resource.rcclchina.com.cn/tui2/user_center/row-banner1.png"
        />
      </div>
      <div class="c_Per personal-intromation-content">
        <div class="personal-intro-title">
          <div class="personal-intro-img">
            <img :src="userAvatar" alt="" @click="toMemberCenter" />
          </div>
          <div class="personal-status-intro">
            <div class="personal-name">
              <span>{{
                userPoint.fullName ? userPoint.fullName : userPoint.mobile
              }}</span>
              <span class="personal-membership"
                ><img
                  v-if="userPoint.userIdentity === 1"
                  :src="userLevelText"
                  @click="toMemberCenter"
              /></span>
            </div>

            <div v-if="userPoint.userIdentity === 1 && !isOverseaUser" class="membership-txt">
              有效积分:
              <span class="memberPoint_js">{{ userInfo.memberPoint }}</span>
            </div>
            <div
              v-if="
                userInfo.infoIntegrity < 100 && userPoint.userIdentity === 1
              "
              class="membership-current personalCenter_bindLoyalty"
            >
              <router-link
                tag="a"
                href="javascript: void(0)"
                :to="`/Rccl.UserCenter/CustomerInfo/EditInfo?returnUrl=${encodeURIComponent(
                  '/Rccl.UserCenter/CustomerInfo/Info'
                )}`"
                >您有<span class="member-num">200</span>积分待领取</router-link
              >
            </div>
            <div
              v-if="userPoint.userIdentity === 0 && !isOverseaUser"
              class="membership-intro upgradeMember-js"
            >
              <div class="membership-name">
                <div class="membership-name-bg"></div>
                <div class="membership-name-txt">
                  <router-link
                    tag="a"
                    to="/Rccl.UserCenter/CustomerInfo/SignUpReward"
                    class="external"
                    >立即升级,<br />
                    <span>赠50美金</span>船上消费金</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="perfect-intro-content">
            <div class="c_exit exit-individual-centers" @click="logout">
              <img src="../../assets/logout.png" /> <span>退出</span>
            </div>
            <div
              v-if="signIn"
              class="c_re_txt perfect-txt next_signInPoint_js f-dn"
              @click="checkedIn"
            >
              <img src="../../assets/mb-sign.png" />
              <span>每日签到</span>
            </div>
            <div
              v-else
              class="c_perfect_txt perfect-txt signInPoint_js"
              @click="signInOk"
            >
              <img src="../../assets/mb-unsign.png" />
              <span>每日签到</span>
            </div>

            <router-link
              tag="div"
              class="suggestions-txt"
              style="margin-left: 9px"
              :to="`/Rccl.UserCenter/CustomerInfo/EditInfo?returnUrl=${encodeURIComponent(
                '/Rccl.UserCenter/CustomerInfo/Info'
              )}`"
            >
              <img src="../../assets/mb-info.png" />
              <span>个人信息</span>
            </router-link>

            <div
              class="perfect-txt c_per_txt"
              v-if="userInfo.loyaltyId && userInfo.loyaltyId.length > 0"
              @click="toOutside('/Rccl.UserCenter/Cas/Index')"
            >
              <img src="../../assets/mb-way.png" />
              <span>查看里程</span>
            </div>
          </div>
        </div>
        <div
          class="personal-center"
          v-if="userPoint && userPoint.userIdentity == 1 && !isOverseaUser"
        >
          <a
            class="external"
            href="javascript: void(0)"
            @click="toOutside(localRewardUrl)"
          >
            <span style="font-weight: bold">皇家游享荟</span>
            <span style="margin-left: 5px">会员中心</span>
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png"
              alt=""
            />
          </a>
        </div>
      </div>
      <router-link
        tag="div"
        to="/Rccl.UserCenter/CustomerInfo/SignUpReward"
        v-if="userPoint.userIdentity === 0 && !isOverseaUser"
        class="personal-img upgradeMember-js"
      >
        <img
          src="https://resource.rcclchina.com.cn/memberCenter/banner.jpg"
          alt=""
        />
      </router-link>
      <div class="order-content">
        <div class="order-tab">
          <div
            class="order-cruiseLink"
            v-bind:class="{ active: cruiseLink === 'ch' }"
            id="homeport-order"
            @click="tabSwitch('ch')"
          >
            <div class="wrapper">
              <div class="order-cruiseLink-bg"></div>
              <span>中国出发航线 </span>
            </div>
          </div>
          <div
            class="order-cruiseLink"
            v-bind:class="{ active: cruiseLink === 'fn' }"
            id="row-order"
            @click="tabSwitch('fn')"
          >
            <div class="wrapper">
              <div class="order-cruiseLink-bg"></div>
              <span>海外出发航线 </span>
            </div>
          </div>
        </div>
        <div class="order-detail-content">
          <div
            class="order-detail-content-list"
            v-bind:class="{ active: cruiseLink === 'ch' }"
          >
            <router-link
              tag="div"
              :to="`/Rccl.UserCenter/OrderRecord/List?isRow=${cruiseLink === 'ch' ? 1 : 2}`"
              class="order-all allOrder"
            >
              <div class="orderAll-img">
                <img
                  src="https://resource.rcclchina.com.cn/tui2/user_center/all_booking.png"
                />
              </div>
              <div class="orderAll-txt">全部订单</div>
            </router-link>
            <router-link
              tag="div"
              :to="`/Rccl.UserCenter/OrderRecord/List?sort=2&isRow=${cruiseLink === 'ch' ? 1 : 2}`"
              class="order-all obligationOrder"
            >
              <div class="orderAll-img">
                <img
                  src="https://resource.rcclchina.com.cn/tui2/user_center/no_pay_booking.png"
                />
                  <span
                  class="obligation-num"
                  v-if="userRelevanceInfo.bookingsCount > 0"
                  >{{ userRelevanceInfo.bookingsCount }}</span
                >
                
                
              </div>
              <div class="orderAll-txt">待付款订单</div>
            </router-link>
            <router-link
              tag="div"
              :to="`/Rccl.UserCenter/OrderRecord/List?sort=3&isRow=${cruiseLink === 'ch' ? 1 : 2}`"
              class="order-all noTripOrder"
            >
              <div class="orderAll-img">
                <img
                  src="https://resource.rcclchina.com.cn/tui2/user_center/paid_booking.png"
                />
              </div>
              <div class="orderAll-txt">已付款订单</div>
            </router-link>
          </div>
          <div
            class="order-detail-content-list"
            v-bind:class="{ active: cruiseLink === 'fn' }"
          >
            <router-link
              tag="div"
              :to="`/Rccl.UserCenter/OrderRecord/List?isRow=${cruiseLink === 'ch' ? 1 : 2}`"
              class="order-all allOrder"
            >
              <div class="orderAll-img">
                <img
                  src="https://resource.rcclchina.com.cn/tui2/user_center/all_booking.png"
                />
              </div>
              <div class="orderAll-txt">全部订单</div>
            </router-link>
            <router-link
              tag="div"
              :to="`/Rccl.UserCenter/OrderRecord/List?sort=2&isRow=${cruiseLink === 'ch' ? 1 : 2}`"
              class="order-all obligationOrder"
            >
              <div class="orderAll-img">
                <img
                  src="https://resource.rcclchina.com.cn/tui2/user_center/no_pay_booking.png"
                />
                
                  <span
                  class="obligation-num"
                  v-if="userRelevanceInfo.rowBookingsCount > 0"
                  >{{ userRelevanceInfo.rowBookingsCount }}</span
                >
              </div>
              <div class="orderAll-txt">待付款订单</div>
            </router-link>
            <router-link
              tag="div"
              :to="`/Rccl.UserCenter/OrderRecord/List?sort=3&isRow=${cruiseLink === 'ch' ? 1 : 2}`"
              class="order-all noTripOrder"
            >
              <div class="orderAll-img">
                <img
                  src="https://resource.rcclchina.com.cn/tui2/user_center/paid_booking.png"
                />
              </div>
              <div class="orderAll-txt">已付款订单</div>
            </router-link>
          </div>
        </div>
      </div>

      <div v-if="bannerTopList.length>0" class="banner-top-list-box">
        <swiper id="bannertTopSwiper" :options="bannerTopListSwiperOptions" class="swiper-wrapper" ref="bannertTopSwiper">
          <swiper-slide style="z-index: 10;" v-for="(banner, index) in bannerTopList" :key="index">
            <div class="swiper-slide">
              <div class="banner-top-list-pic">
                <template v-if="banner.link">
                  <a :href="banner.link">
                    <img :src="banner.image" alt="" class="item-banner" />
                  </a>
                </template>
                <template v-else>
                  <img :src="banner.image" alt="" class="item-banner" />
                </template>
              </div>
            </div>
          </swiper-slide>
          <div v-show="bannerTopList.length>1" class="banner-pagination" slot="pagination"></div>
        </swiper>
      </div>

<!--      <div class="enterpriseWx-banner" v-if="userPoint && userPoint.userIdentity == 1 && !isOverseaUser">-->
<!--        <a href="http://mobile.rcclchina.com.cn/privilege/WeComLandingpage/weworkbanner?hmsr=mb&hmpl=banner&hmcu=wework">-->
<!--          <img v-oss-img src="https://resource.rcclchina.com.cn/userCenter/bannerWeComAddFriends_v1.0.png" alt="">-->
<!--        </a>-->
<!--      </div>-->
      <div class="tabulation-list">
        <router-link
          tag="div"
          class="favorite-tabulation border-grey"
          to="/Rccl.UserCenter/UserCoupon/UserCoupon?isExpired=1"
        >
          <div class="favorite-tabulation-txt">
            <img
              style="width: 21px"
              src="https://resource.rcclchina.com.cn/tui2/user_center/coupon.png"
            />
            <span>优惠券</span>
          </div>
          <div class="tips" v-if="userInfo.noUsedCouponCount > 0">
            有<span style="color: red">{{ userInfo.noUsedCouponCount }}</span
            >张可用的优惠券
          </div>
          <div class="favorite-tabulation-img">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png"
            />
          </div>
        </router-link>
        <router-link
          tag="div"
          class="favorite-tabulation border-grey"
          to="/Rccl.UserCenter/WishList/List"
        >
          <div class="favorite-tabulation-txt">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/wishlist.png"
            />
            <span>收藏夹</span>
          </div>
          <div class="tips" v-if="userInfo.wishlistCount > 0">
            有<span style="color: red">{{ userInfo.wishlistCount }}</span
            >条航线即将售罄
          </div>
          <div class="favorite-tabulation-img">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png"
            />
          </div>
        </router-link>
        <div
          class="favorite-tabulation border-grey"
          @click="
            toOutside(
              `${localRewardHost}/reward/recommend/courtesy?token=${localRewardToken}`
            )
          "
        >
          <div class="favorite-tabulation-txt">
            <img src="../../assets/mb-recommend.png" />
            <span>推荐有礼</span>

            <img class="hot" src="../../assets/hot.png" alt="hot" />
          </div>
          <div class="favorite-tabulation-img">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png"
            />
          </div>
        </div>
        <div
          class="favorite-tabulation border-grey"
          @click="
            toOutside(
              `${localRewardHost}/reward/member/shop/index?token=${localRewardToken}`
            )
          "
        >
          <div class="favorite-tabulation-txt">
            <img src="../../assets/mb-jifen.png" />
            <span>积分商城</span>
          </div>
          <div class="favorite-tabulation-img">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png"
            />
          </div>
        </div>
        <div
          class="favorite-tabulation border-grey"
          @click="
            toOutside(
              `${localRewardHost}/reward/member/shop/gift?token=${localRewardToken}`
            )
          "
        >
          <div class="favorite-tabulation-txt">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/gift.png"
            />
            <span>我的礼品</span>
          </div>
          <div class="favorite-tabulation-img">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png"
            />
          </div>
        </div>
        <router-link
          tag="div"
          class="favorite-tabulation border-grey"
          to="/Rccl.UserCenter/UserContact/List"
        >
          <div class="favorite-tabulation-txt">
            <img
              style="width: 16px"
              src="https://resource.rcclchina.com.cn/tui2/user_center/contact.png"
            />
            <span>常用联系人</span>
          </div>
          <div class="favorite-tabulation-img">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png"
            />
          </div>
        </router-link>
        <router-link
          tag="div"
          class="favorite-tabulation border-grey"
          to="/Rccl.UserCenter/Suggestion/Index"
        >
          <div class="favorite-tabulation-txt">
            <img
              style=""
              src="https://resource.rcclchina.com.cn/MobileMemberClub/1.png"
            />
            <span>意见建议</span>
          </div>
          <div class="favorite-tabulation-img">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png"
            />
          </div>
        </router-link>
        <router-link
          tag="div"
          class="favorite-tabulation border-grey"
          to="/Rccl.Review/ReviewPicture/OwnPicture"
        >
          <div class="favorite-tabulation-txt">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/review.png"
            />
            <span>游记美图</span>
          </div>
          <div class="favorite-tabulation-img">
            <img
              src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png"
            />
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
export default {
  name: "UserCenterHome",
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      userToken: "",
      cruiseLink: "ch", // ch 国内出发航线 fn 海外出发航线
      userInfo: {},
      userPoint: {},
      userRelevanceInfo: {},
      userAvatar: "",
      userLevelText: "",
      signInPoint: 1,
      signIn: false, // 是否签到
      isShowSignIn: false,
      continuousSigInDays: 0,
      bannerTopList: [],
      bannerTopListSwiperOptions: {
        // loop: true,
        pagination: {
          type: 'bullets',
          el: '.banner-pagination', // 分页器所在的DOM节点，可以是CSS选择器或者DOM对象
          clickable: true // 允许点击分页器上的按钮跳转到对应的幻灯片
        }
      },
    };
  },
  beforeMount() {
    this.$store.commit("SET_PAGE_TITLE", "个人中心");
    this.showPage();
    this.getSignInCount()
  },
  methods: {
    async showPage() {
      this.$loading.show();
      await this.initPage();
      await this.getBannerList();
      this.$loading.hide();
      await this.$store.dispatch('HIDE_HEADER_BAR', {isHideHeader: false, isHideFooter: false})
    },
    async initPage() {
      const userToken = this.$store.state.user.userToken;
      if (!userToken && userToken.length == 0) {
        this.$router.push(
          `/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(
            window.location.pathname
          )}`
        );
        return;
      }
      this.userToken = userToken;

      await this.$store.dispatch("GET_USER_INFO", userToken);
      this.userPoint = this.$store.state.user.userInfo;
      this.userInfo = await this.getUserInfo(userToken);
      this.signIn = this.userInfo.memberIsSignIn;

      // 渲染头像和等级
      this.userAvatar = this.getUserAvatar(this.userPoint);
      this.userLevelText = this.getUserLevelText(this.userPoint);

      // 待付款订单
      this.userRelevanceInfo = await this.getUserRelevanceInfoHP(userToken);
    },
    async getUserInfo(userToken) {
      const { success, data, errMsg } = await api.user.getUserAllInfo(
        userToken
      );
      if (!success) console.log(errMsg);
      return data;
    },
    async getUserRelevanceInfoHP(userToken) {
      const { success, data, errMsg } = await api.user.userRelevanceInfoHP(
        userToken
      );
      if (!success) console.log(errMsg);
      return data;
    },
    toOutside(url) {
      window.location.href = url;
    },
    toMemberCenter() {
      if (this.userPoint.userIdentity || this.isOverseaUser) {
        return false;
      } else {
        window.location.href =
          this.localRewardHost +
          "/reward/member/welfare?token=" +
          this.localRewardToken;
      }
    },
    tabSwitch(route) {
      this.cruiseLink = route;
    },
    getUserAvatar(userInfo) {
      if (userInfo.userIdentity === 0) {
        return "https://resource.rcclchina.com.cn/logo/MB/logoAvatarCircleBlueLarge.png";
      } else {
        let level = userInfo.levelEN.replace(/T/g, "");
        return `https://resource.rcclchina.com.cn/MobileMemberClub/lv${level}.png`;
      }
    },
    getUserLevelText(userInfo) {
      if (userInfo.userIdentity === 0) {
        return "";
      } else {
        let level = userInfo.levelEN.replace(/T/g, "");
        return `https://resource.rcclchina.com.cn/MobileMemberClub/lv${level}_text.png`;
      }
    },
    logout() {
      this.$store.commit("REMOVE_USER_TOKEN");
      this.$router.push(
        `/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(
          window.location.pathname
        )}`
      );
    },
    async signInOk() {
      const { success, data, errMsg } = await api.user.signIn({
        userName: this.userToken,
      });
      if (!success) {
        console.log(errMsg);
        this.$alert.show(errMsg);
        return;
      }
      if (data) {
        if (typeof data === "number" && data > 0) {
          this.signInPoint = data;
          this.userInfo.memberPoint += data;
        }
        this.isShowSignIn = true;
        this.signIn = true;
        await this.getSignInCount()
      }
    },
    async getSignInCount(){
      const { success, data, errMsg } = await api.user.getSignInCount({
        userName: this.userToken,
      });
      if (!success) {
        console.log(errMsg);
        this.$alert.show(errMsg);
        return;
      }
      if (success){
        this.continuousSigInDays = data
      }
    },
    checkedIn() {
      this.isShowSignIn = true;
    },
    closeCheckedIn() {
      this.isShowSignIn = false;
    },
    closeSignIn() {
      this.isShowSignIn = false;
    },
    rowOrderRecord(sort) {
      return encodeURIComponent(
        process.env.VUE_APP_TUI_URL +
          "/UserCenter/MobileOrderRecord?sort=" +
          sort
      );
    },
    async getBannerList() {
      const { success, data, errMsg } = await api.page.getBannerApi({
        BusinessType: 11
      });
      if(success) {
        this.bannerTopList = data || []
      } else {
        console.log(errMsg)
      }
    }
  },
  computed: {
    localRewardToken() {
      if (!this.$store.state.user.userInfo) {
        return "";
      }
      return this.$store.state.user.userInfo.localRewardToken;
    },
    localRewardHost() {
      return process.env.VUE_APP_REWARD_URL;
    },
    localRewardUrl() {
      return `${process.env.VUE_APP_REWARD_URL}/reward?token=${this.localRewardToken}`;
    },
		isOverseaUser() {
			const userInfo = this.$store.state.user.userInfo
			if (!userInfo || !userInfo.callingCode) {
				return false;
			}
      return (
        userInfo != null &&
        userInfo.callingCode != "86" &&
        userInfo.callingCode != "+86"
      );
    },
  },
};
</script>

<style scoped>
img {
  width: 100%;
}

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

div.page-content {
  background: #f5f6f7;
}

/*签到成功样式*/
.sign-popup {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  text-align: center;
}
.sign-imgpopup {
  width: 232px;
  height: 146px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.sign-close {
  width: 30px;
}
.sign-text {
  position: absolute;
  top: 10px;
  left: 50%;
  width: 100%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  color: #fff;
  font-size: 16px;
  letter-spacing: 1px;
  margin-top: 20px;
}
.sign-text .num {
  font-weight: bold;
}
.sign-text .txt {
  font-size: 12px;
}

.individual-center {
  padding-bottom: 35px;
  width: 100%;
}

.individual-center .banner {
  width: 100%;
  height: 182px;
}

.individual-center .banner img {
  display: none;
}

.individual-center .banner img.active {
  display: block;
}

.individual-center .personal-intromation-content {
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 152px 15px 0 15px;
  position: relative;
  z-index: 1;
  color: #333;
}

.personal-intro-title .personal-intro-img,
.personal-intro-title .personal-status-intro,
.personal-intro-title .perfect-intro-content,
.membership-intro .membership-name,
.membership-intro .exit-individual-centers {
  display: inline-block;
  vertical-align: top;
}
.personal-intro-title .perfect-intro-content {
  position: relative;
  top: -5px;
  vertical-align: top;
}

.personal-intro-title .perfect-intro-content.no_loyalty {
  width: auto;
}

.personal-intro-title .personal-intro-img {
  width: 60px;
  height: 60px;
  overflow: hidden;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  margin-left: 12px;
  position: relative;
  vertical-align: top;
  margin-top: -6px;
  margin-right: 5px;
}
.c_Per .personal-intro-title .personal-intro-img > img {
  width: 60px;
  margin-top: -4px;
  margin-left: -5px;
}

.personal-intro-img img {
  width: 50px;
  position: relative;
  top: 5px;
  left: 5px;
}
.personal-status-intro .personal-name {
  font-family: PingFang-SC-Medium;
  font-size: 15px;
  color: #333;
  letter-spacing: 0;
  margin-bottom: 1px;
}

.personal-name > span {
  display: inline-block;
  max-width: 102px;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
}
.personal-name > span.personal-membership {
  width: 60px;
  height: 20px;
}
.membership-txt {
  font-size: 12px;
  color: #333;
}
.membership-current {
  font-size: 12px;
  color: #4a90e2;
}

.membership-current .member-num {
  color: #ff5055;
}
.personal-status-intro .membership-num,
.membership-name span,
.exit-individual-centers,
.perfect-intro-content .perfect-txt span,
.perfect-intro-content .suggestions-txt span {
  font-size: 12px;
}

.membership-name {
  display: inline-block;
}

.membership-name span {
  margin-left: 5px;
  color: white;
  position: relative;
  z-index: 1;
  display: block;
}
.membership-name img,
.perfect-intro-content .perfect-txt img,
.perfect-intro-content .suggestions-txt img {
  width: 15px;
  vertical-align: -2px;
  margin-right: 5px;
}
.membership-intro {
  margin-top: 2px;
}

.membership-intro .membership-name {
  position: relative;
  vertical-align: initial;
}
.perfect-intro-content .perfect-txt span,
.perfect-intro-content .suggestions-txt span {
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
}
.c_exit.exit-individual-centers {
  margin-left: 15px;
}
.exit-individual-centers {
  margin-left: 18px;
  display: block;
  padding-left: 15px;
  position: absolute;
  top: -135px;
  right: -15px;
}
.exit-individual-centers span {
  font-family: PingFang-SC-Medium;
  font-size: 14px;
  color: #fff;
  letter-spacing: 0;
}

.exit-individual-centers img {
  width: 15px;
  position: relative;
  vertical-align: middle;
}
.exit-individual-centers > span {
  vertical-align: middle;
}

.membership-name .membership-name-txt {
  padding: 1px 14px 1px 0;
}
.membership-name-txt > a {
  display: block;
  font-size: 12px;
  margin-left: 3px;
}
.membership-name-txt > a span {
  color: #ff211f;
  display: inline;
  margin-left: 0;
}
.membership-name-txt img {
  width: 67px;
}

.personal-status-intro .membership-num {
  margin-bottom: 5px;
}
.personal-intro-title .personal-status-intro {
  width: 170px;
  position: relative;
  top: -3px;
  margin-right: 5px;
}
.personal-intro-title .personal-status-intro.c_per_intro {
  top: -3px;
}
.personal-intro-title .personal-status-intro.no_loyalty {
  width: 170px;
}

.personal-intromation-content .personal-intro-title {
  vertical-align: middle;
  padding-top: 18px;
  padding-bottom: 5px;
  margin-top: -200px;
}
.c_Per.personal-intromation-content .personal-intro-title {
  border-bottom: 1px solid #dbe9f9;
}
.personal-img {
  margin: 6px 15px 6px 15px;
}
.personal-img > img {
  width: 100%;
  display: block;
}
.personal-intromation-content .personal-center {
  font-size: 14px;
  text-align: center;
  line-height: 34px;
  height: 36px;
}
.personal-intromation-content .personal-center a {
  color: #4a90e2;
}
.personal-intromation-content .personal-center img {
  width: 8px;
  vertical-align: middle;
  margin-left: 3px;
}
.personal-intromation-content .personal-center span {
  vertical-align: middle;
}
.perfect-txt.c_re_txt {
  margin-left: 9px;
  margin-top: 2px;
  margin-bottom: 1px;
}
.perfect-intro-content .c_perfect_txt {
  margin-left: 9px;
  margin-top: 2px;
  margin-bottom: 1px;
}
.perfect-txt.c_per_txt,
.suggestions-txt.c_sug_txt {
  margin-left: 9px;
}
.perfect-intro-content .perfect-txt.c_perfect_txt span {
  color: #febc11;
}
.perfect-intro-content .suggestions-txt {
  position: relative;
}
.perfect-intro-content .suggestions-txt i {
  background: url("../../assets/statusImg.png") no-repeat;
  background-size: 5px 5px;
}
.perfect-intro-content .suggestions-txt i {
  position: absolute;
  width: 5px;
  height: 5px;
  display: inline-block;
  top: 7px;
  right: -7px;
}
.systemMessage-content {
  background: #4e91d2;
}
.systemMessage-content .system-txt,
.systemMessage-content .system-img {
  display: inline-block;
  vertical-align: middle;
}
.systemMessage-content .system-img {
  position: relative;
}
.systemMessage-content .system-txt {
  font-size: 12px;
  color: #fff;
  width: 340px;
  padding: 10px 20px;
}
.systemMessage-content .system-txt a {
  color: white;
}

.systemMessage-content .system-img img {
  width: 20px;
  vertical-align: text-bottom;
}
.systemMessage-content .system-img i {
  position: absolute;
  width: 5px;
  height: 5px;
  top: 0;
  right: -5px;
  background: url("../../assets/statusImg.png") no-repeat;
  background-size: 5px 5px;
}
.order-content {
  background-color: transparent;
  padding-bottom: 0;
  margin-top: 12px;
  position: relative;
}
.order-content .order-detail-content {
  text-align: center;
  background-color: white;
  height: 124px;
  box-shadow: 0 1.5px 2px 0 #d6d7d8;
}

.order-detail-content .order-detail-content-list {
  display: none;
  position: relative;
  top: 26px;
}

.order-detail-content .order-detail-content-list.active {
  display: block;
}

.order-detail-content .order-all {
  display: inline-block;
  width: 98px;
  margin-right: 15px;
}
.order-detail-content .obligationOrder,
.order-detail-content .noTripOrder {
  position: relative;
}
.order-detail-content .orderAll-txt {
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
}
.orderAll-img img {
  width: 46px;
}
.obligationOrder .obligation-num,
.noTripOrder .noTrip-num {
  position: absolute;
  top: -3px;
  right: 23px;
  width: 16px;
  height: 16px;
  background: #ff211f;
  border-radius: 15px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 16px;
}
.tabulation-list {
  position: relative;
  //top: -10px;
  padding-bottom: 20px;
  margin-top: 15px;
}
.tabulation-list .favorite-tabulation {
  background: #fff;
  border-bottom: 1px solid #ccc;
  padding: 18px 22px;
  position: relative;
}

.favorite-tabulation .favorite-tabulation-img {
  position: absolute;
  right: 19px;
  top: 17px;
}

.favorite-tabulation-img img {
  width: 8px;
  vertical-align: text-bottom;
}
.favorite-tabulation .favorite-tabulation-txt img {
  width: 20px;
  vertical-align: middle;
  display: inline-block;
}
.favorite-tabulation .favorite-tabulation-txt {
  font-family: PingFang-SC-Medium;
  font-size: 14px;
  color: #4a90e2;
  letter-spacing: 0;
  display: inline-block;
  vertical-align: middle;
}
.favorite-tabulation .favorite-tabulation-txt span {
  margin-left: 9px;
  vertical-align: middle;
  display: inline-block;
}
.favorite-tabulation .favorite-tabulation-txt img.hot {
  width: 38px;
  vertical-align: -6px;
  margin-left: 3px;
}

.favorite-tabulation .tips {
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  text-align: right;
  margin-right: 20px;
  display: inline-block;
  vertical-align: middle;
  float: right;
  position: relative;
  top: 7px;
}

.common-contact-content .common-contact {
  display: inline-block;
  text-align: center;
  color: #333333;
  font-size: 12px;
  width: 85px;
  position: relative;
}
.common-contact-content {
  background: #fff;
  margin-top: 10px;
  padding: 25px;
}
.common-contact .common-contact-img img {
  width: 20px;
}
.common-contact-content .travel-chart {
  margin: 0 30px;
}
.common-contact .common-contact-img {
  padding-bottom: 5px;
}

.hold_link {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/**** 海外航线跳转 ****/
.order-tab {
  position: relative;
  width: 100%;
  height: 50px;
}

.order-tab .order-cruiseLink {
  position: absolute;
  width: 200px;

  text-align: center;
  z-index: 1;
  font-family: PingFang-SC-Medium;
  font-size: 13px;
  color: #999999;
  letter-spacing: 1px;
  text-align: center;
  line-height: 15px;
  height: 57px;
  top: -4px;
}

.order-tab .order-cruiseLink.active {
  height: 50px;
  top: 0px;
  z-index: 2;
}

.order-tab .order-cruiseLink span {
  position: relative;
  z-index: 3;
  top: 20px;
}

.order-tab .active span {
  color: white;
  top: 17px;
}

.order-cruiseLink-bg {
  position: absolute;
  background-image: url("https://resource.rcclchina.com.cn/tui2/user_center/order-tab.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
}

.order-tab .active .order-cruiseLink-bg {
  background-image: url("https://resource.rcclchina.com.cn/tui2/user_center/order-tab-selected.png");
  background-size: 100% 100%;
  z-index: 2;
  top: 0px;
}

#homeport-order {
  left: 0px;
}

#row-order {
  right: 0px;
}

#homeport-order .order-cruiseLink-bg {
  transform: rotateY(180deg);
}

#homeport-order.active .order-cruiseLink-bg {
  transform: rotateY(0deg);
}

#row-order .order-cruiseLink-bg {
  transform: rotateY(0deg);
}

#row-order.active .order-cruiseLink-bg {
  transform: rotateY(180deg);
}

.cruiseLink {
  position: relative;
  background-color: #e4e4e4;
  padding-top: 10px;
}
.cruiseLink .cruiseLink-bg {
  width: 100%;
}
.cruiseLink .cruiseLink-info {
  width: 100%;
  text-align: center;
  height: 26px;
  position: absolute;
  top: 50%;
  margin-top: -13px;
}
.cruiseLink .cruiseLink-info img {
  display: inline-block;
  vertical-align: middle;
  width: 19px;
  height: 20px;
}
.cruiseLink .cruiseLink-info span {
  display: inline-block;
  vertical-align: middle;
  color: #fff;
  font-size: 16px;
  font-style: initial;
}
.cruiseLink .hold-link {
  display: inline-block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

/**** noUsedCouponCount ****/
.noUsedCouponCount {
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background: #ff211f;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
}

/*popup*/
.popup {
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.popup.modal-out {
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

div.content-block {
  padding: 0px;
  margin: 0px;
}

.pop-nav {
  display: block;
  position: relative;
  height: 50px;
}

.pop-nav a {
  width: 50px;
  position: absolute;
  display: block;
  height: 100%;
  z-index: 1;
}

.pop-nav a img {
  width: 10px;
  position: relative;
  left: 20px;
  top: 16px;
}

.pop-nav-title {
  position: relative;
  top: 15px;
  text-align: center;
}

.coupon-popup-bg {
  height: 10px;
  background-color: #f6f7f8;
}
.enterpriseWx-banner{
  padding: 0 15px;
  height: 68px;
  margin: 15px 0;
  img{
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
}
</style>

<style lang="less" scoped>
.banner-top-list-box {
  width: 345px;
  height: 80px;
  margin: 15px auto 0;
  .swiper-wrapper {
    width: 100%;
    height: 80px;
  }
  .banner-top-list-pic {
    position: relative;
    width: 100%;
    height: 80px;
    img {
      width: 100%;
      height: 100%;
    }
    & .item-banner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
<style lang="less">
.banner-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
  font-size: 0;
  line-height: 6px;
  &.swiper-pagination-bullets {
    bottom: 10px;
    height: 6px;
    & .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #FFFFFF;
      opacity: .6;
    }
    .swiper-pagination-bullet-active {
      border-radius: 6px;
      width: 16px;
    }
  }
}
</style>
